import { SplashHandle, useAppSplash } from '@context'
import React, { useEffect } from 'react'

interface SplashSignalProps {
  source: string
}

export const SplashSignal: React.FC<SplashSignalProps> = ({ source }) => {
  const { show, hide } = useAppSplash()

  useEffect(() => {
    const handle: SplashHandle = show(source)
    return () => hide(handle)
  }, [show, hide, source])

  return null
}

export default SplashSignal
